import type { BenchmarkMetrics, CaseRunResult } from "./types";

export function computeMetrics(results: CaseRunResult[]): BenchmarkMetrics {
  const errorCount = results.filter((r) => r.status === "failed").length;
  const scoredResults = results.filter(
    (r) => r.status === "complete" || r.status === "abandoned",
  );
  const totalCases = scoredResults.length;

  if (totalCases === 0) {
    return {
      accuracy: 0,
      precision: null,
      recall: null,
      totalCases: results.length,
      passedCases: 0,
      errorCount,
    };
  }

  let passedCases = 0;
  let casesWithRecommendations = 0;
  let correctRecommendations = 0;
  let casesExpectingRecommendations = 0;
  let foundRecommendations = 0;

  for (const result of scoredResults) {
    if (result.isPass) {
      passedCases++;
    }

    const recommendedSomething = result.actualSuggestions.length > 0;

    // For Precision: When the model did recommend something, how often was it right?
    if (recommendedSomething) {
      casesWithRecommendations++;
      if (result.isPass) {
        correctRecommendations++;
      }
    }

    // For Recall: Out of all the products the model should have recommended, how many did it find?
    if (!result.expectsNone) {
      casesExpectingRecommendations++;
      if (result.isPass) {
        foundRecommendations++;
      }
    }
  }

  const accuracy = totalCases > 0 ? passedCases / totalCases : 0;
  const precision = casesWithRecommendations > 0 ? correctRecommendations / casesWithRecommendations : null;
  const recall = casesExpectingRecommendations > 0 ? foundRecommendations / casesExpectingRecommendations : null;

  return {
    accuracy,
    precision,
    recall,
    totalCases: results.length,
    passedCases,
    errorCount,
  };
}
